import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Business } from '../models/business.model';
import { EditAddAirportComponent } from '../edit-add-airport/edit-add-airport.component';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { AirportService } from '../../airport/airport.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { ConfirmRemoveAirportComponent } from '../confirm-remove-airport/confirm-remove-airport.component';
import { hasTag } from '../../util/tag-utils';
var AssociatedAirportsComponent = /** @class */ (function () {
    function AssociatedAirportsComponent(_addAirportsDialog, _toggleService, _airportService, _businessService, snackBar) {
        this._addAirportsDialog = _addAirportsDialog;
        this._toggleService = _toggleService;
        this._airportService = _airportService;
        this._businessService = _businessService;
        this.snackBar = snackBar;
        this.editModeSet = false;
        this.isAmbassador = false;
        this.isRegionalManager = false;
    }
    AssociatedAirportsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        if (!(hasTag(this.business.tags, 'Flying Club') && this.business.flyingClub)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._businessService.isAmbassador()];
                    case 1:
                        _a.isAmbassador = _d.sent();
                        _d.label = 2;
                    case 2:
                        _b = this;
                        return [4 /*yield*/, this._businessService.isRegionalManager()];
                    case 3:
                        _c = (_d.sent());
                        if (!_c) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._businessService.userOwnsBusiness(this.business.id)];
                    case 4:
                        _c = !(_d.sent());
                        _d.label = 5;
                    case 5:
                        _b.isRegionalManager = _c;
                        return [2 /*return*/];
                }
            });
        });
    };
    AssociatedAirportsComponent.prototype.openAddAirportsDialog = function () {
        var _this = this;
        var dialogRef = this._addAirportsDialog.open(EditAddAirportComponent, {
            disableClose: false,
            autoFocus: true,
            data: {
                business: this.business
            }
        });
        dialogRef.afterClosed().subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // Update the business object on close, since it could've been changed
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                    case 1:
                        // Update the business object on close, since it could've been changed
                        _a.business = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AssociatedAirportsComponent.prototype.removeAirport = function (airport) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogRef = this._addAirportsDialog.open(ConfirmRemoveAirportComponent, {
                    disableClose: false,
                    autoFocus: true,
                    data: {
                        airportSummary: airport
                    }
                });
                dialogRef.afterClosed().subscribe(function (confirmed) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var responseString, _a;
                    return tslib_1.__generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!confirmed) {
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, this._businessService.removeAssociatedAirport(this.business, airport.airportId)];
                            case 1:
                                responseString = _b.sent();
                                if (!!responseString.includes('deleted')) return [3 /*break*/, 2];
                                this.snackBar.open("Failed to Remove " + airport.faaId + " from " + this.business.name, 'Close', {
                                    duration: 2000
                                });
                                return [3 /*break*/, 4];
                            case 2:
                                _a = this;
                                return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                            case 3:
                                _a.business = _b.sent();
                                _b.label = 4;
                            case 4: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    return AssociatedAirportsComponent;
}());
export { AssociatedAirportsComponent };
